import React from 'react'
import { Link } from 'react-router'
import { Container, Row, Col, Button, InputGroup, InputGroupAddon, Input, Label, FormGroup } from 'reactstrap';

class StatusChoices extends React.Component {

	constructor(props) {
	  super(props);
	}


	render(){
		const { provider } = this.props

		return(
            <div className="bloc-login">
                <form  role="form" >

                        <FormGroup check>
				            <Label check>
				              <Input type="radio" name="radio1" onChange={() => this.props.onChangeChoices("A")} />{' '}
				              Acceptée
				            </Label>
			           </FormGroup>

			           <FormGroup check>
				            <Label check>
				              <Input type="radio" name="radio1" onChange={() => this.props.onChangeChoices("W")} />{' '}
				              Stand-by
				            </Label>
			           </FormGroup>

			           <FormGroup check>
				            <Label check>
				              <Input type="radio" name="radio1" onChange={() => this.props.onChangeChoices("R")} />{' '}
				              Refusée
				            </Label>
			           </FormGroup>
                            
                     <div className="center validate">
                        <Button className="btn-green">Valider</Button>
                    </div>
                </form>
            </div>
		)
	}
}


export default StatusChoices


// WEBPACK FOOTER //
// ./src/provider/components/status/StatusChoices.js